import React from 'react'

import { Image, Text } from '@chakra-ui/react'

import getAttachmentPostV2Icon from '@page/post-v2/helpers/getAttachmentPostV2Icon'
import type { ApplicationFileV2 } from '@page/post-v2/types'
import './PostPageV2File.scss'

type FileLike = Partial<ApplicationFileV2> & {
    name?: string
    filename?: string
    ext?: string
    size?: number
    uid?: string
    uploaded?: string
}

interface PostPageV2FileProps {
    file: FileLike
    onClick?: React.MouseEventHandler<HTMLDivElement>
}

const baseClass = 'PostPageV2File'

function formatFileSize(sizeInBytes?: number) {
    if (typeof sizeInBytes !== 'number' || Number.isNaN(sizeInBytes) || sizeInBytes < 0) {
        return '0 B'
    }
    const units = ['B', 'KB', 'MB', 'GB', 'TB']
    let size = sizeInBytes
    let unitIndex = 0

    while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024
        unitIndex += 1
    }

    const formattedSize = Number(size.toFixed(1)).toString()

    return `${formattedSize} ${units[unitIndex]}`
}

function PostPageV2File({ file, onClick }: PostPageV2FileProps) {
    const fileName = file.filename ?? file.name ?? 'Untitled file'
    const fileExt = file.ext ?? ''
    const fileSize = typeof file.size === 'number' ? file.size : 0

    return (
        <div className={baseClass} onClick={onClick} role="presentation">
            <Image maxW={'22px'} src={getAttachmentPostV2Icon(fileExt)} alt={fileName} />

            <div className={`${baseClass}__info`}>
                <Text
                    className={`${baseClass}__name`}
                    whiteSpace={'nowrap'}
                    overflow={'hidden'}
                    textOverflow={'ellipsis'}
                    maxW={'100%'}
                    color={'#0C0C0D'}
                    fontWeight={'500'}
                    fontSize={'12px'}
                    flexShrink={'1'}
                    flexGrow={'1'}
                >
                    {fileName}
                </Text>
                <Text
                    className={`${baseClass}__size`}
                    whiteSpace={'nowrap'}
                    overflow={'hidden'}
                    textOverflow={'ellipsis'}
                    maxW={'100%'}
                    color={'#717175'}
                    fontWeight={'500'}
                    fontSize={'10px'}
                    flexShrink={'1'}
                    flexGrow={'1'}
                >
                    {formatFileSize(fileSize)}
                </Text>
            </div>
        </div>
    )
}

export default PostPageV2File
